import { getAppValue } from "src/utils/environment";

export const colorMap = {
  activityLog: getAppValue({
    bibino: "tintPurple",
    barkio: ""
  }),
  everyNoise: "tintTurquoise",
  audioFiles: "tintOrange",
  pairedDevices: "tintRed",
  settings: "primary",
  mute: "tintRed",
  noiseSensitivity: "tintPurple",
  avatars: "tintTurquoise",
  pairDevice: "tintGreen",
  account: "tintPurple",
  motionDetection: "tintRed",
  deviceName: "tintPink",
  events: "tintOrange",
  advanced: "tintPurple",
  help: "tintPink",
  community: "tintBlue",
  contact: "tintGreen",
  debug: "mediumEmphasis",
  miniWindow: "tintBlue",
  general: "tintPurple",
  appVersion: "mediumEmphasis",
  scheduler: "tintGreen",
  alerts: "tintBlue",
  videoSettings: "tintRed"
};
